let videoTabsContainer = document.getElementsByClassName("video-tab-header")[0];
let videoTabsBody = document.querySelector(".video-tab-body");
var productvideo = document.getElementById("feature-video");
var videoPlayer = document.getElementsByClassName("feature-video");
var playhead = document.querySelector(".playhead");
var btn = document.getElementById("playpause");
const fullscreen   =  document.querySelector('.fullscreen');

var controlAreaTime = 1;
var flatFaceTime = 1;
var squaredEdgeTime = 1;
var shavedHeadTime = 1;
var knifeHeadTime = 1;
var recurvedToeTime = 1;
var balancedToeTime = 1;
var slingGrooveTime = 1;
var powerSpineTime = 1;
var reducedHeadTime = 1;
var stickBowTime = 1;
var stickCarbonTime = 1;
var powerZoneTime = 1;

var stickModel = {
    currentStick: "hockey-stick",
    info : document.getElementsByClassName('video-container'),
    stickProduct : function(hockeyStick) {
        var className = this.info;
        for (var i = 0; i < className.length; i++) {
            hockeyStick = className[i].id;
        }
        this.currentStick = hockeyStick;
    }
}

stickModel.stickProduct();

let adbFeatureTab = '<div id="control-area" class="video-active">Control Area</div><div id="reduced-head">Reduced Head</div><div id="balanced-toe">Balanced Toe</div><div id="power-zone">Powerzone</div><div id="stick-bow">Bow</div><div id="stick-carbon">Y1 Carbon</div>';
let lbFeatureTab = '<div id="control-area" class="video-active">Control Area</div><div id="flat-face">Shaved Head</div><div id="recurved-toe">Recurved Toe</div><div id="stick-carbon">Y1 Carbon</div><div id="power-zone">Powerzone</div><div id="stick-bow">Bow</div>';
let glbFeatureTab = '<div id="control-area" class="video-active">Control Area</div><div id="flat-face">FlatFace</div><div id="squared-edge">Squared Edge</div><div id="stick-bow">Bow</div><div id="stick-carbon">Y1 Carbon</div>';
let mrFeatureTab = '<div id="control-area" class="video-active">Control Area</div><div id="flat-face">FlatFace</div><div id="power-spine">Power Spine</div><div id="stick-bow">Bow</div><div id="stick-carbon">Y1 Carbon</div>';


function setPlayerFeatures(findModel) {

  let hockeyStickModel = findModel;
  
      switch(hockeyStickModel) {
       case "glb":
              controlAreaTime = 6;
              flatFaceTime = 10;
              squaredEdgeTime = 19;
              stickBowTime = 23;
              stickCarbonTime = 27;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = glbFeatureTab;              
            break;
        case "lb":
              controlAreaTime = 4;
              recurvedToeTime = 9;
              flatFaceTime = 15;
              stickCarbonTime = 21;
              powerZoneTime = 25;
              stickBowTime = 30;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = lbFeatureTab;
              break;
          case "lbx":
              controlAreaTime = 4;
              flatFaceTime = 9;
              recurvedToeTime = 15;
              stickCarbonTime = 21;
              powerZoneTime = 25;
              stickBowTime = 30;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = lbFeatureTab;
              break;
          case "adb":
              controlAreaTime = 4;
              reducedHeadTime = 9;
              balancedToeTime = 15;
              stickCarbonTime = 21;
              powerZoneTime = 25;
              stickBowTime = 30;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = adbFeatureTab;
              break;
           case "adbx":
              controlAreaTime = 4;
              reducedHeadTime = 9;
              balancedToeTime = 15;
              stickCarbonTime = 21;
              powerZoneTime = 25;
              stickBowTime = 30;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = adbFeatureTab;
              break;
            case "mrx":
              controlAreaTime = 4;
              flatFaceTime = 9;
              powerSpineTime = 18;
              stickBowTime = 24;
              stickCarbonTime = 29;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = mrFeatureTab;
              break;
            case "mr":
              controlAreaTime = 4;
              flatFaceTime = 9;
              powerSpineTime = 15;
              stickBowTime = 18;
              stickCarbonTime = 23;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = mrFeatureTab;
              break;
             case "ylbx":
              controlAreaTime = 4;
              flatFaceTime = 9;
              knifeHeadTime = 15;
              powerZoneTime = 26;
              stickBowTime = 30;
              stickCarbonTime = 21;
              slingGrooveTime = 33;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = '<div id="control-area" class="video-active">Control Area</div><div id="flat-face">Knife Head</div><div id="power-zone">Power Zone</div><div id="stick-bow">Bow</div><div id="stick-carbon">Y1 Carbon</div><div id="sling-groove">Sling Groove</div>';
              break;
            case "glbx":
              controlAreaTime = 6;
              flatFaceTime = 10;
              squaredEdgeTime = 19;
              stickBowTime = 23;
              stickCarbonTime = 27;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = '<div id="control-area" class="video-active">Control Area</div><div id="flat-face">FlatFace</div><div id="squared-edge">Squared Edge</div><div id="stick-bow">Bow</div><div id="stick-carbon">Y1 Carbon</div>';
              break;

            case "ylb":
             controlAreaTime = 4;
              flatFaceTime = 9;
              knifeHeadTime = 15;
              powerZoneTime = 26;
              stickBowTime = 30;
              stickCarbonTime = 21;
              slingGrooveTime = 33;
              var featureControls = document.createElement("div"); 
              featureControls.classList.add('video-tabs');
              featureControls.innerHTML = '<div id="control-area" class="video-active">Control Area</div><div id="flat-face">FlatFace</div><div id="power-zone">Power Zone</div><div id="stick-bow">Bow</div><div id="stick-carbon">Y1 Carbon</div><div id="sling-groove">Sling Groove</div>';
              break;
            default:
              controlAreaTime = 1;
         }
       return featureControls;
}

videoTabsContainer.append(setPlayerFeatures(stickModel.currentStick));

let videoTabs = document.getElementsByClassName("video-tabs")[0];
let videoTabIndicator = document.getElementsByClassName("video-tab-indicator")[0];
let videoTabBody = document.getElementsByClassName("video-tab-body")[0];
let videoTabsPane = videoTabs.getElementsByTagName("div");


for (let i=0;i<videoTabsPane.length;i++){

    let tabCount = videoTabsPane.length;
    const width = `calc(100% / ${tabCount})`;
    videoTabIndicator.style.width = width;
  
      videoTabsPane[i].addEventListener("click",function(){
      
        videoTabs.getElementsByClassName("video-active")[0].classList.remove("video-active");
        videoTabsPane[i].classList.add("video-active"); 
        
        if (videoTabBody.getElementsByClassName("videoinfotab")[i]) {
            videoTabBody.getElementsByClassName("video-active")[0].classList.remove("video-active");
            videoTabBody.getElementsByClassName("videoinfotab")[i].classList.add("video-active");
        } 
      
        videoTabIndicator.style.left = `calc(${width} * ${i})`;
        videoTabIndicator.style.width = width;
    });
}


let controlArea = document.querySelector("#control-area");
let flatFace = document.querySelector("#flat-face"); 
let squaredEdge = document.querySelector("#squared-edge");
let shavedHead = document.querySelector("#shaved-head");
let knifeHead = document.querySelector("#knife-head");
let slingGroove = document.querySelector("#sling-groove");
let powerSpine = document.querySelector("#power-spine");
let powerZone = document.querySelector("#power-zone");
let reducedHead = document.querySelector("#reduced-head");
let recurvedToe = document.querySelector("#recurved-toe");
let balancedToe = document.querySelector("#balanced-toe");
let stickBow = document.querySelector("#stick-bow");
let stickCarbon = document.querySelector("#stick-carbon");


function handleEvent(event, videoTime) {
  event.preventDefault();
  productvideo.play();
  productvideo.pause();
  productvideo.currentTime = videoTime;
  togglePlayPause();
}

function setupButtonListener(selector, videoTime) {
  const element = selector;
  element?.addEventListener('click', (event) => handleEvent(event, videoTime));
}

setupButtonListener(controlArea, controlAreaTime);
setupButtonListener(flatFace, flatFaceTime);
setupButtonListener(squaredEdge, squaredEdgeTime);
setupButtonListener(shavedHead, shavedHeadTime);
setupButtonListener(knifeHead, knifeHeadTime);
setupButtonListener(slingGroove, slingGrooveTime);
setupButtonListener(powerSpine, powerSpineTime);
setupButtonListener(reducedHead, reducedHeadTime);
setupButtonListener(balancedToe, balancedToeTime);
setupButtonListener(recurvedToe, recurvedToeTime);
setupButtonListener(slingGroove, slingGrooveTime);
setupButtonListener(stickBow, stickBowTime);
setupButtonListener(stickCarbon, stickCarbonTime);
setupButtonListener(powerZone, powerZoneTime);


function togglePlayPause() {
  console.log("Toggle play/pause");
  if (productvideo !== undefined) {
    if (productvideo.paused) {
      btn.innerHTML = '<i class="fa fa-pause"></i>';
      productvideo.play();
    } else {
      btn.innerHTML = '<i class="fa fa-play"></i>';
      productvideo.pause();
    }
  }
}


// Create fullscreen video button
function toggleFullscreen() {
	console.log("Toggle fullscreen");
	if(productvideo.requestFullScreen){
		productvideo.requestFullScreen();
	} else if(productvideo.webkitRequestFullScreen){
		productvideo.webkitRequestFullScreen();
	} else if(productvideo.mozRequestFullScreen){
		productvideo.mozRequestFullScreen();
	}
}

fullscreen.addEventListener('click', toggleFullscreen);


btn.addEventListener("click", function () {
  togglePlayPause();
}, false);

productvideo.addEventListener("click", function () {
  togglePlayPause();
}, false);


productvideo.addEventListener("timeupdate", function() {
  console.log("Time update");
  var playheadPos = productvideo.currentTime / productvideo.duration;
  playhead.style.width = playheadPos * 100 + "%";
  
  if (productvideo.ended) {
    btn.className = "play";
  }
});


const modelViewer = document.getElementById('product-model-features');

if (modelViewer) {
  modelViewer.insertAdjacentHTML('afterbegin', `
    <button class="Hotspot" slot="hotspot-1" data-position="-0.018752709070974958m 0.18000654654511639m -0.00048607101851838586m" data-normal="-0.001004723185978806m -0.008495569906190152m -0.9999634072421294m" data-visibility-attribute="visible">
      <div class="HotspotAnnotation">SLING GROOVE</div>
    </button>

    <button class="Hotspot" slot="hotspot-3" data-position="0.029966507515192777m 0.02509271984338901m -0.015199106638790538m" data-normal="-0.04886425572277023m 0.2965138108818639m -0.9537776703556098m" data-visibility-attribute="visible">
      <div class="HotspotAnnotation">CONTROL AREA</div>
    </button>

    <button class="Hotspot" slot="hotspot-4" data-position="0.04787938981321038m 0.008255694986749718m -0.01868793520286942m" data-normal="0.5210914968257868m -0.7083876787049214m -0.47607830090743897m" data-visibility-attribute="visible">
      <div class="HotspotAnnotation">FLAT FACE</div>
    </button>

    <button class="Hotspot" slot="hotspot-5" data-position="0.0036969418220745703m 0.18175949640112543m 0.008818791697686623m" data-normal="0.9614727049710144m -0.003489972812441954m 0.2748782597541847m" data-visibility-attribute="visible">
      <div class="HotspotAnnotation">POWER ZONE</div>
    </button>
  `);

}